import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logoGold from "../assets/logo-gold.png";
import BookCTA from "./BookCTA";
import "./Nav.css";

const LINKS = [
  { path: "/",          label: "Home",       end: true  },
  { path: "/services",  label: "Services",   end: false },
  { path: "/products",  label: "Products",   end: false },
  { path: "/process",   label: "How We Work",end: false },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`nav ${scrolled || open ? "nav--solid" : ""}`}>
      <div className="nav-inner container">
        <Link
          to="/"
          className="nav-brand"
          aria-label="EffiGen home"
          onClick={() => setOpen(false)}
        >
          <img src={logoGold} alt="" className="nav-logo" />
          <span className="nav-wordmark">EffiGen.AI</span>
        </Link>

        <nav
          className={`nav-links ${open ? "nav-links--open" : ""}`}
          aria-label="Primary"
        >
          {LINKS.map((l) => (
            <NavLink
              key={l.path}
              to={l.path}
              end={l.end}
              className="nav-link"
              onClick={() => setOpen(false)}
            >
              {l.label}
            </NavLink>
          ))}
          <BookCTA
            ctaLocation="nav"
            className="btn-primary nav-cta"
            onClick={() => setOpen(false)}
          >
            Book a Consultation
          </BookCTA>
        </nav>

        <button
          className="nav-burger"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          {/* An SVG, not three flexed <span> bars: Safari collapses flex items
              whose flex-basis resolves from a 2px height, which left the button
              looking empty on iOS. An SVG has intrinsic size and cannot. */}
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            aria-hidden="true"
            focusable="false"
          >
            {open ? (
              <>
                <path d="M4.5 4.5l13 13" />
                <path d="M17.5 4.5l-13 13" />
              </>
            ) : (
              <>
                <path d="M3 6h16" />
                <path d="M3 11h16" />
                <path d="M3 16h16" />
              </>
            )}
          </svg>
        </button>
      </div>
    </header>
  );
};

export default Nav;
